import React from "react";
import SectionHeader from "./SectionHeader";
import FadeIn from "./FadeIn";

interface CurrentFocusProps {
  onNavigate: (page: string, slug?: string) => void;
}

export default function CurrentFocus({ onNavigate }: CurrentFocusProps) {
  const focusItems = [
    {
      title: "Reverse Material You",
      slug: "reverse-material-you",
      description:
        "Inverting Material You — instead of deriving a palette from a wallpaper, it repaints the wallpaper in a palette, snapping every pixel to its nearest color in perceptually uniform OKLCH space.",
      tags: ["Rust", "OKLCH", "CLI"],
      github: "https://github.com/nvimbtw/Reverse-Material-You",
    },
    {
      title: "Raytracer",
      slug: "raytracer",
      description:
        "Building a high-performance, multithreaded CPU-based ray tracer from scratch in Rust. Exploring computer graphics fundamentals and lighting models.",
      tags: ["Rust", "Graphics", "Multithreading"],
      github: "https://github.com/nvimbtw/raytracer",
    },
    {
      title: "Neovim Configuration",
      slug: "nvim",
      description:
        "Crafting a personalized development environment (PDE) for maximum coding velocity. Lua-based, lazy-loaded, and tailored for TypeScript & Rust.",
      tags: ["LUA", "NVIM"],
      github: "https://github.com/nvimbtw/nvim",
    },
    {
      title: "Leaf Venation Patterns",
      slug: "leaf-venation-patterns",
      description:
        "Biological simulation modeling how veins grow in leaves through auxin particle interactions. Visualizes realistic branching patterns.",
      tags: ["C#", "Raylib", "Simulation"],
      github: "https://github.com/nvimbtw/LeafVenationPatterns",
    },
  ];

  return (
    <section id="active-processes" className="w-full py-28 md:py-36 px-6 md:px-12 bg-Base border-t hairline selection:bg-Sapphire selection:text-Base">
      <div className="max-w-4xl w-full mx-auto">
        <SectionHeader number="05" label="Projects" title="Selected Work" />

        <FadeIn>
        <div>
          {focusItems.map((item, index) => (
            <div
              key={index}
              onClick={() => onNavigate("project", item.slug)}
              className="group cursor-pointer border-t hairline py-10 transition-colors duration-200"
            >
              <div className="flex justify-between items-baseline mb-3">
                <h3 className="font-display font-medium text-Text text-3xl group-hover:text-Sapphire transition-colors duration-200">
                  {item.title}
                  <span className="inline-block ml-3 text-Sapphire opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 text-2xl">
                    →
                  </span>
                </h3>
                <a
                  href={item.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="font-mono text-xs text-Subtext0 hover:text-Sapphire transition-colors uppercase tracking-[0.15em]"
                  title="View source on GitHub"
                >
                  GitHub ↗
                </a>
              </div>

              <p className="text-Subtext0 mb-4 font-sans text-base leading-relaxed max-w-2xl">
                {item.description}
              </p>

              <p className="label-caps">{item.tags.join(" · ")}</p>
            </div>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
